// import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import { ClientProvider } from './hooks/useClient'
import { RedirectProvider } from './hooks/useRedirectPAge.jsx'

import { NavigationProvider } from './hooks/useNavigation'
import './i18n/index'
import { initAnalytics } from './utils/analytics.js'
import { setupAuthGuards } from './utils/setupAuthGuards.js'
// import { CheckUserMissionProvider } from './contexts/userMissions/CheckUserMissionContext.jsx'
import { ChatTimerProvider } from './contexts/ChatTimerContext/ChatTimerContext.jsx'
import { IntlContextProvider } from './contexts/IntlContext/IntlContext.jsx'
import { ArtPendingProvider } from './contexts/ArtPendingContext/ArtPendingContext.jsx'
import { SideMenuProvider } from './contexts/SideMenuContext/CheckUserMissionContext.jsx'
import { CampaignSidebarProvider } from './contexts/CampaignSidebarContext/CampaignSidebarContext.jsx'
import { PaywallProvider } from './contexts/PaywallContext/PaywallContext.jsx'
import { ArtsLimitUpsellProvider } from './contexts/ArtsLimitUpsellContext/ArtsLimitUpsellContext.jsx'
import { GoogleOAuthProvider } from '@react-oauth/google'
initAnalytics()
setupAuthGuards()

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID
const isValidGoogleClientId =
  typeof googleClientId === 'string' && googleClientId.endsWith('.apps.googleusercontent.com')

if (!isValidGoogleClientId) {
  console.error(
    'Invalid VITE_GOOGLE_CLIENT_ID. Use the Google OAuth 2.0 Web client ID from Google Cloud Console, ending with .apps.googleusercontent.com.'
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={googleClientId}>
    <BrowserRouter>
      <AuthProvider>
        <ClientProvider>
          <ChatTimerProvider>
            <IntlContextProvider>
              {/* <CheckUserMissionProvider> */}
              <NavigationProvider>
                <RedirectProvider>
                  <ArtPendingProvider>
                    <SideMenuProvider>
                      <CampaignSidebarProvider>
                        <PaywallProvider>
                          <ArtsLimitUpsellProvider>
                            <App />
                          </ArtsLimitUpsellProvider>
                        </PaywallProvider>
                      </CampaignSidebarProvider>
                    </SideMenuProvider>
                  </ArtPendingProvider>
                </RedirectProvider>
              </NavigationProvider>
              {/* </CheckUserMissionProvider> */}
            </IntlContextProvider>
          </ChatTimerProvider>
        </ClientProvider>
      </AuthProvider>
    </BrowserRouter>
  </GoogleOAuthProvider>
  // </React.StrictMode>,
)
